<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Vannmåler</h2>
    </v-flex>
    <v-flex xs12>
      <BooleanInput v-model="stepValues.bool" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <v-flex xs12 class="mb-3" v-if="stepValues.bool.isWaterMeter.value">
      <v-layout wrap>
        <v-flex xs12>
          <h4>Vannmåler:</h4>
        </v-flex>
        <v-flex xs12 sm6 class="text-center pr-sm-3">
          <v-text-field
            :type="stepValues.numbers.waterMeterNumber.type"
            :label="stepValues.numbers.waterMeterNumber.label"
            v-model="stepValues.numbers.waterMeterNumber.value"
            @input="updateFields"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 class="text-center pl-sm-3">
          <v-text-field
            :type="stepValues.numbers.waterMeterValue.type"
            :label="stepValues.numbers.waterMeterValue.label"
            v-model="stepValues.numbers.waterMeterValue.value"
            @input="updateFields"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <h4>Varmtvann:</h4>
        </v-flex>
        <v-flex xs12 sm6 class="text-center pr-sm-3">
          <v-text-field
            :type="stepValues.numbers.warmWaterMeterNumber.type"
            :label="stepValues.numbers.warmWaterMeterNumber.label"
            v-model="stepValues.numbers.warmWaterMeterNumber.value"
            @input="updateFields"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 class="text-center pl-sm-3">
          <v-text-field
            :type="stepValues.numbers.warmWaterMeterValue.type"
            :label="stepValues.numbers.warmWaterMeterValue.label"
            v-model="stepValues.numbers.warmWaterMeterValue.value"
            @input="updateFields"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <h4>Kaldtvann:</h4>
        </v-flex>
        <v-flex xs12 sm6 class="text-center pr-sm-3">
          <v-text-field
            :type="stepValues.numbers.coldWaterMeterNumber.type"
            :label="stepValues.numbers.coldWaterMeterNumber.label"
            v-model="stepValues.numbers.coldWaterMeterNumber.value"
            @input="updateFields"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 class="text-center pl-sm-3">
          <v-text-field
            :type="stepValues.numbers.coldWaterMeterValue.type"
            :label="stepValues.numbers.coldWaterMeterValue.label"
            v-model="stepValues.numbers.coldWaterMeterValue.value"
            @input="updateFields"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <h4>Fjernvarme:</h4>
        </v-flex>
        <v-flex xs12 sm6 class="text-center pr-sm-3">
          <v-text-field
            :type="stepValues.numbers.farWaterMeterNumber.type"
            :label="stepValues.numbers.farWaterMeterNumber.label"
            v-model="stepValues.numbers.farWaterMeterNumber.value"
            @input="updateFields"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 class="text-center pl-sm-3">
          <v-text-field
            :type="stepValues.numbers.farWaterMeterValue.type"
            :label="stepValues.numbers.farWaterMeterValue.label"
            v-model="stepValues.numbers.farWaterMeterValue.value"
            @input="updateFields"
            box
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-checkbox v-model="stepValues.selfCalc" @change="updateFields" label="Partene har selv avregnet vannmålere"></v-checkbox>
        </v-flex>
        <v-flex xs12>
          <v-checkbox v-model="stepValues.brokerHelp" @change="updateFields" label="Partene ønsker at megler avregner vannmålere (gjøres kun dersom beløp er over kr 1.000,-)"></v-checkbox>
        </v-flex>
      </v-layout>
    </v-flex>
    <ImageUploadBox :images="stepValues.images"></ImageUploadBox>
    <StepButtons @next-page="next" @previous-page="previous" />
  </div>
</template>

<script>
import step from "../../../mixins/step";
export default {
   mixins: [step]
};
</script>